/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { LazyHorizontalNavQueue } from '@jira/navigation-apps__horizontal-nav-jsm-queue/src/async-for-paint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { customPracticeQueueCalendarRoute } from '@jira/router-routes__servicedesk-queue-routes/src/customPracticeQueueCalendarRoute.tsx';
import { getQueuesResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { uifBoardResource } from '@jira/router-resources__uif-board/src/uifBoardResource.tsx';
import { getCalendarFilterFieldsResource } from '@jira/router-resources__service-desk-calendar/src/useCalendarFilterResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { CalendarSkeleton, calendarPageEntryPoint } from './ui/calendar/index.tsx';

export const customPracticeQueueCalendarRouteEntry: Route = createEntry(
	customPracticeQueueCalendarRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		forPaint: [LazyAtlassianNavigation, LazyHorizontalNavQueue],

		entryPoint: () => {
			if (fg('jsm_views_inside_queues_-_main_flag')) {
				return calendarPageEntryPoint;
			}
			return undefined;
		},

		skeleton: CalendarSkeleton,

		resources: [
			...getQueuesResources(),
			getConsolidationStateResource(),
			getCalendarFilterFieldsResource(),
			resourceWithCondition(() => !__SERVER__, uifBoardResource),
		],

		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
